import axios from 'axios';
import Auth from '../../auth/auth';

export const dataDictionaryViewActions = {
  LOAD_OBJECTS_REQUEST: 'DD_VIEW_LOAD_OBJECTS_REQUEST',
  LOAD_OBJECTS_SUCCESS: 'DD_VIEW_LOAD_OBJECTS_SUCCESS',
  LOAD_OBJECTS_FAILURE: 'DD_VIEW_LOAD_OBJECTS_FAILURE',

  SEARCH_OBJECTS_REQUEST: 'DD_VIEW_SEARCH_OBJECTS_REQUEST',
  SEARCH_OBJECTS_SUCCESS: 'DD_VIEW_SEARCH_OBJECTS_SUCCESS',
  SEARCH_OBJECTS_FAILURE: 'DD_VIEW_SEARCH_OBJECTS_FAILURE',

  LOAD_OBJECT_DETAILS_REQUEST: 'DD_VIEW_LOAD_OBJECT_DETAILS_REQUEST',
  LOAD_OBJECT_DETAILS_SUCCESS: 'DD_VIEW_LOAD_OBJECT_DETAILS_SUCCESS',
  LOAD_OBJECT_DETAILS_FAILURE: 'DD_VIEW_LOAD_OBJECT_DETAILS_FAILURE',
  LOAD_OBJECT_RELATED_REQUEST: 'DD_VIEW_LOAD_OBJECT_RELATED_REQUEST',
  LOAD_OBJECT_RELATED_SUCCESS: 'DD_VIEW_LOAD_OBJECT_RELATED_SUCCESS',
  LOAD_OBJECT_RELATED_FAILURE: 'DD_VIEW_LOAD_OBJECT_RELATED_FAILURE',
  LOAD_OBJECT_HISTORY_REQUEST: 'DD_VIEW_LOAD_OBJECT_HISTORY_REQUEST',
  LOAD_OBJECT_HISTORY_SUCCESS: 'DD_VIEW_LOAD_OBJECT_HISTORY_SUCCESS',
  LOAD_OBJECT_HISTORY_FAILURE: 'DD_VIEW_LOAD_OBJECT_HISTORY_FAILURE',

  LOAD_CATEGORIES_REQUEST: 'DD_VIEW_LOAD_CATEGORIES_REQUEST',
  LOAD_CATEGORIES_SUCCESS: 'DD_VIEW_LOAD_CATEGORIES_SUCCESS',
  LOAD_CATEGORIES_FAILURE: 'DD_VIEW_LOAD_CATEGORIES_FAILURE',

  LOAD_SCHEMAS_REQUEST: 'DD_VIEW_LOAD_SCHEMAS_REQUEST',
  LOAD_SCHEMAS_SUCCESS: 'DD_VIEW_LOAD_SCHEMAS_SUCCESS',
  LOAD_SCHEMAS_FAILURE: 'DD_VIEW_LOAD_SCHEMAS_FAILURE',

  SET_SELECTED_LETTER: 'DD_VIEW_SET_SELECTED_LETTER',
  SET_CATEGORY_FILTER: 'DD_VIEW_SET_CATEGORY_FILTER',
  SET_SCHEMA_FILTER: 'DD_VIEW_SET_SCHEMA_FILTER',
  SET_SEARCH_TERM: 'DD_VIEW_SET_SEARCH_TERM',

  // Reports
  LOAD_PII_REPORT_REQUEST: 'DD_VIEW_LOAD_PII_REPORT_REQUEST',
  LOAD_PII_REPORT_SUCCESS: 'DD_VIEW_LOAD_PII_REPORT_SUCCESS',
  LOAD_PII_REPORT_FAILURE: 'DD_VIEW_LOAD_PII_REPORT_FAILURE',

  LOAD_AI_ELIGIBLE_REPORT_REQUEST: 'DD_VIEW_LOAD_AI_ELIGIBLE_REPORT_REQUEST',
  LOAD_AI_ELIGIBLE_REPORT_SUCCESS: 'DD_VIEW_LOAD_AI_ELIGIBLE_REPORT_SUCCESS',
  LOAD_AI_ELIGIBLE_REPORT_FAILURE: 'DD_VIEW_LOAD_AI_ELIGIBLE_REPORT_FAILURE',

  LOAD_OWNERSHIP_REPORT_REQUEST: 'DD_VIEW_LOAD_OWNERSHIP_REPORT_REQUEST',
  LOAD_OWNERSHIP_REPORT_SUCCESS: 'DD_VIEW_LOAD_OWNERSHIP_REPORT_SUCCESS',
  LOAD_OWNERSHIP_REPORT_FAILURE: 'DD_VIEW_LOAD_OWNERSHIP_REPORT_FAILURE',

  LOAD_SCHEMA_AUDIT_REPORT_REQUEST: 'DD_VIEW_LOAD_SCHEMA_AUDIT_REPORT_REQUEST',
  LOAD_SCHEMA_AUDIT_REPORT_SUCCESS: 'DD_VIEW_LOAD_SCHEMA_AUDIT_REPORT_SUCCESS',
  LOAD_SCHEMA_AUDIT_REPORT_FAILURE: 'DD_VIEW_LOAD_SCHEMA_AUDIT_REPORT_FAILURE',

  LOAD_USAGE_REPORT_REQUEST: 'DD_VIEW_LOAD_USAGE_REPORT_REQUEST',
  LOAD_USAGE_REPORT_SUCCESS: 'DD_VIEW_LOAD_USAGE_REPORT_SUCCESS',
  LOAD_USAGE_REPORT_FAILURE: 'DD_VIEW_LOAD_USAGE_REPORT_FAILURE',

  DOWNLOAD_REPORT_REQUEST: 'DD_VIEW_DOWNLOAD_REPORT_REQUEST',
  DOWNLOAD_REPORT_SUCCESS: 'DD_VIEW_DOWNLOAD_REPORT_SUCCESS',
  DOWNLOAD_REPORT_FAILURE: 'DD_VIEW_DOWNLOAD_REPORT_FAILURE',

  REFRESH_USAGE_REPORT_REQUEST: 'DD_VIEW_REFRESH_USAGE_REPORT_REQUEST',
  REFRESH_USAGE_REPORT_SUCCESS: 'DD_VIEW_REFRESH_USAGE_REPORT_SUCCESS',
  REFRESH_USAGE_REPORT_FAILURE: 'DD_VIEW_REFRESH_USAGE_REPORT_FAILURE',
};

const auth = new Auth();
const { getAccessToken } = auth;

//--------- Load Objects by Letter -----------
export function loadObjects(startWith, categories = [], schemas = []) {
  return function(dispatch) {
    dispatch({ type: dataDictionaryViewActions.LOAD_OBJECTS_REQUEST });
    let url = process.env.REACT_APP_API_URL + '/dataDictionary/objects/view/summary?startsWith=' + startWith;
    
    // Add category filter if provided
    if (categories && categories.length > 0) {
      url += '&objectType=' + categories.join(',');
    }

    // Add schema filter if provided
    if (schemas && schemas.length > 0) {
      url += '&schemaId=' + schemas.join(',');
    }
    
    
    
    axios.get(url, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': getAccessToken()
      }
    })
    .then(response => {
      // Check if the API returned success status
      if (response.data && response.data.status === false) {
        throw new Error(response.data.error || 'Failed to load objects');
      }
      
      return response.data;
    })
    .then((json) => {
      dispatch({ 
        type: dataDictionaryViewActions.LOAD_OBJECTS_SUCCESS, 
        payload: json 
      });
    })
    .catch((error) => {
      console.error('ACTION - loadObjects - API error:', error);
      dispatch({ 
        type: dataDictionaryViewActions.LOAD_OBJECTS_FAILURE, 
        payload: error, 
        error: true 
      });
    });
  };
}

//--------- Load Object Details -----------
export function loadObjectDetails(objectId) {
  return function(dispatch) {
    dispatch({ type: dataDictionaryViewActions.LOAD_OBJECT_DETAILS_REQUEST });
    const url = process.env.REACT_APP_API_URL + '/dataDictionary/objects/view?objectId=' + objectId;
    
    axios.get(url, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': getAccessToken()
      }
    })
    .then(response => {
        
      console.log('ACTION - loadObjectDetails - API response:', response.data);
      // Check if the API returned success status
      if (response.data && response.data.status === false) {
        throw new Error(response.data.error || 'Failed to load object details');
      }
      
      return response.data;
    })
    .then((json) => {
      dispatch({ 
        type: dataDictionaryViewActions.LOAD_OBJECT_DETAILS_SUCCESS, 
        payload: json 
      });
    })
    .catch((error) => {
      console.error('ACTION - loadObjectDetails - API error:', error);
      dispatch({ 
        type: dataDictionaryViewActions.LOAD_OBJECT_DETAILS_FAILURE, 
        payload: error, 
        error: true 
      });
    });
  };
}

export function loadObjectRelated(objectId) {
  return function(dispatch) {
    dispatch({ type: dataDictionaryViewActions.LOAD_OBJECT_RELATED_REQUEST });
    const url = process.env.REACT_APP_API_URL + '/dataDictionary/objects/related?objectId=' + objectId;

    axios.get(url, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': getAccessToken()
      }
    })
    .then((response) => {
      dispatch({
        type: dataDictionaryViewActions.LOAD_OBJECT_RELATED_SUCCESS,
        payload: response.data.response
      });
    })
    .catch((error) => {
      dispatch({
        type: dataDictionaryViewActions.LOAD_OBJECT_RELATED_FAILURE,
        payload: error.message || error,
        error: true
      });
    });
  };
}

export function loadObjectHistory(objectId) {
  return function(dispatch) {
    dispatch({ type: dataDictionaryViewActions.LOAD_OBJECT_HISTORY_REQUEST });
    const url = process.env.REACT_APP_API_URL + '/dataDictionary/objects/history?objectId=' + objectId;

    axios.get(url, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': getAccessToken()
      }
    })
    .then((response) => {
      dispatch({
        type: dataDictionaryViewActions.LOAD_OBJECT_HISTORY_SUCCESS,
        payload: response.data.response
      });
    })
    .catch((error) => {
      dispatch({
        type: dataDictionaryViewActions.LOAD_OBJECT_HISTORY_FAILURE,
        payload: error.message || error,
        error: true
      });
    });
  };
}

//--------- Set Selected Letter -----------
export function setSelectedLetter(letter) {
  return {
    type: dataDictionaryViewActions.SET_SELECTED_LETTER,
    payload: letter
  };
}

//--------- Set Category Filter -----------
export function setCategoryFilter(categories) {
  return {
    type: dataDictionaryViewActions.SET_CATEGORY_FILTER,
    payload: categories
  };
}

//--------- Set Schema Filter -----------
export function setSchemaFilter(schemas) {
  return {
    type: dataDictionaryViewActions.SET_SCHEMA_FILTER,
    payload: schemas
  };
}

//--------- Set Search Term -----------
export function setSearchTerm(searchTerm) {
  return {
    type: dataDictionaryViewActions.SET_SEARCH_TERM,
    payload: searchTerm
  };
}

//--------- Search Objects -----------
export function searchObjects(keyword, objectTypes = [], schemas = []) {
  return function(dispatch) {
    dispatch({ type: dataDictionaryViewActions.SEARCH_OBJECTS_REQUEST });
    let url = process.env.REACT_APP_API_URL + '/dataDictionary/objects/view/search?keyword=' + encodeURIComponent(keyword);
    
    // Add objectType filter if provided (can be none, one, or many)
    if (objectTypes && objectTypes.length > 0) {
      url += '&objectType=' + objectTypes.join(',');
    }

    // Add schema filter if provided
    if (schemas && schemas.length > 0) {
      url += '&schemaId=' + schemas.join(',');
    }

    console.log('ACTION - searchObjects - API URL:', url);
    
    axios.get(url, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': getAccessToken()
      }
    })
    .then(response => {
      if (response.data && response.data.status === false) {
        throw new Error(response.data.error || 'Failed to search objects');
      }
      return response.data;
    })
    .then((json) => {
      dispatch({ 
        type: dataDictionaryViewActions.SEARCH_OBJECTS_SUCCESS, 
        payload: json 
      });
    })
    .catch((error) => {
      console.error('ACTION - searchObjects - API error:', error);
      dispatch({ 
        type: dataDictionaryViewActions.SEARCH_OBJECTS_FAILURE, 
        payload: error, 
        error: true 
      });
    });
  };
}

//--------- Load Categories -----------
export function loadCategories() {
  return function(dispatch) {
    dispatch({ type: dataDictionaryViewActions.LOAD_CATEGORIES_REQUEST });
    axios.get(process.env.REACT_APP_API_URL + '/dataDictionary/objects/view/types', {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': getAccessToken()
      }
    })
    .then(response => {
        console.log('ACTION - loadCategories - API response:', response.data);
      if (response.data && response.data.status === false) {
        throw new Error(response.data.error || 'Failed to load categories');
      }
      return response.data;
    })
    .then((json) => {
      dispatch({ 
        type: dataDictionaryViewActions.LOAD_CATEGORIES_SUCCESS, 
        payload: json 
      });
    })
    .catch((error) => {
      console.error('ACTION - loadCategories - API error:', error);
      dispatch({ 
        type: dataDictionaryViewActions.LOAD_CATEGORIES_FAILURE, 
        payload: error, 
        error: true 
      });
    });
  };
}

//--------- Load Schemas -----------
export function loadSchemas() {
  return function(dispatch) {
    dispatch({ type: dataDictionaryViewActions.LOAD_SCHEMAS_REQUEST });
    axios.get(process.env.REACT_APP_API_URL + '/dataDictionary/schemas', {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': getAccessToken()
      }
    })
    .then(response => {
      if (response.data && response.data.status === false) {
        throw new Error(response.data.error || 'Failed to load schemas');
      }
      return response.data;
    })
    .then((json) => {
      dispatch({ 
        type: dataDictionaryViewActions.LOAD_SCHEMAS_SUCCESS, 
        payload: json 
      });
    })
    .catch((error) => {
      console.error('ACTION - loadSchemas - API error:', error);
      dispatch({ 
        type: dataDictionaryViewActions.LOAD_SCHEMAS_FAILURE, 
        payload: error, 
        error: true 
      });
    });
  };
}

// ── Report Thunks ─────────────────────────────────────────────────────────────

function buildReportUrl(reportType, filters = {}) {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.set(key, value);
    }
  });
  const qs = params.toString();
  return `${process.env.REACT_APP_API_URL}/dataDictionary/reports/${reportType}${qs ? '?' + qs : ''}`;
}

function makeReportThunk(requestType, successType, failureType, reportType) {
  return function(filters = {}) {
    return function(dispatch) {
      dispatch({ type: requestType });
      axios.get(buildReportUrl(reportType, filters), {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token': getAccessToken()
        }
      })
      .then(response => {
        if (response.data && response.data.status === false) {
          throw new Error(response.data.error || `Failed to load ${reportType} report`);
        }
        return response.data;
      })
      .then((json) => {
        dispatch({ type: successType, payload: json });
      })
      .catch((error) => {
        console.error(`ACTION - load ${reportType} report - API error:`, error);
        dispatch({ type: failureType, payload: error, error: true });
      });
    };
  };
}

export const loadPiiReport = makeReportThunk(
  dataDictionaryViewActions.LOAD_PII_REPORT_REQUEST,
  dataDictionaryViewActions.LOAD_PII_REPORT_SUCCESS,
  dataDictionaryViewActions.LOAD_PII_REPORT_FAILURE,
  'pii'
);

export const loadAiEligibleReport = makeReportThunk(
  dataDictionaryViewActions.LOAD_AI_ELIGIBLE_REPORT_REQUEST,
  dataDictionaryViewActions.LOAD_AI_ELIGIBLE_REPORT_SUCCESS,
  dataDictionaryViewActions.LOAD_AI_ELIGIBLE_REPORT_FAILURE,
  'ai-eligible'
);

export const loadOwnershipReport = makeReportThunk(
  dataDictionaryViewActions.LOAD_OWNERSHIP_REPORT_REQUEST,
  dataDictionaryViewActions.LOAD_OWNERSHIP_REPORT_SUCCESS,
  dataDictionaryViewActions.LOAD_OWNERSHIP_REPORT_FAILURE,
  'ownership'
);

export const loadSchemaAuditReport = makeReportThunk(
  dataDictionaryViewActions.LOAD_SCHEMA_AUDIT_REPORT_REQUEST,
  dataDictionaryViewActions.LOAD_SCHEMA_AUDIT_REPORT_SUCCESS,
  dataDictionaryViewActions.LOAD_SCHEMA_AUDIT_REPORT_FAILURE,
  'schema-audit'
);

export const loadUsageReport = makeReportThunk(
  dataDictionaryViewActions.LOAD_USAGE_REPORT_REQUEST,
  dataDictionaryViewActions.LOAD_USAGE_REPORT_SUCCESS,
  dataDictionaryViewActions.LOAD_USAGE_REPORT_FAILURE,
  'usage'
);

function triggerBlobDownload(blobData, contentType, fallbackFilename, disposition) {
  const parts = disposition ? disposition.split('filename=') : [];
  const filename = parts.length >= 2 ? parts[1].replace(/"/g, '') : fallbackFilename;
  const url = window.URL.createObjectURL(new Blob([blobData], { type: contentType }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

//--------- Download Report (authenticated blob download) -----------
export function downloadReport(reportType, filters = {}) {
  return function(dispatch) {
    dispatch({ type: dataDictionaryViewActions.DOWNLOAD_REPORT_REQUEST, payload: { reportType } });
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.set(key, value);
      }
    });
    const qs = params.toString();
    // PDF suffix must come before query params, so we build the URL directly
    // rather than reusing buildReportUrl which appends filters at the end.
    const url = `${process.env.REACT_APP_API_URL}/dataDictionary/reports/${reportType}/pdf${qs ? '?' + qs : ''}`;
    const dateStr = new Date().toISOString().slice(0, 10);
    axios.get(url, {
      headers: { 'x-access-token': getAccessToken() },
      responseType: 'blob',
      timeout: 60000,
    })
      .then((response) => {
        triggerBlobDownload(
          response.data,
          'application/pdf',
          `${reportType}-report-${dateStr}.pdf`,
          response.headers['content-disposition']
        );
        dispatch({ type: dataDictionaryViewActions.DOWNLOAD_REPORT_SUCCESS, payload: { reportType } });
      })
      .catch((error) => {
        dispatch({ type: dataDictionaryViewActions.DOWNLOAD_REPORT_FAILURE, payload: error, error: true });
      });
  };
}

//--------- Refresh Usage Report (POST /dataDictionary/reports/usage/refresh) -----------
export function refreshUsageReport(payload = {}) {
  return function(dispatch) {
    dispatch({ type: dataDictionaryViewActions.REFRESH_USAGE_REPORT_REQUEST });
    axios.post(
      `${process.env.REACT_APP_API_URL}/dataDictionary/reports/usage/refresh`,
      payload,
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token': getAccessToken()
        }
      }
    )
    .then(response => {
      if (response.data && response.data.status === false) {
        throw new Error(response.data.error || 'Failed to refresh usage report');
      }
      return response.data;
    })
    .then((json) => {
      dispatch({ type: dataDictionaryViewActions.REFRESH_USAGE_REPORT_SUCCESS, payload: json });
    })
    .catch((error) => {
      console.error('ACTION - refreshUsageReport - API error:', error);
      dispatch({ type: dataDictionaryViewActions.REFRESH_USAGE_REPORT_FAILURE, payload: error, error: true });
    });
  };
}
